// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 6832 ? "vitrine" : chunkId) + "." + {"2672":"a968bd24f63a3ae9d63b","6832":"0ab7fdc6cef242cd15ed"}[chunkId] + ".css";
};